import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is PSD design in web development?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "PSD design refers to creating a website layout or UI in Adobe Photoshop, saved as a .PSD file, which can later be converted to HTML or other code."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide custom PSD designs?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I create custom PSD designs tailored to your branding, content, and business goals — whether it’s a website, landing page, or mobile app."
      }
    },
    {
      "@type": "Question",
      "name": "Can you convert PSD to HTML?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. I offer PSD to responsive HTML/CSS conversion services, ensuring pixel-perfect output that works across all devices and browsers."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need PSD files if I'm using WordPress?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "PSD files are useful for planning custom layouts and designs before development. I can design in PSD and then develop it into a WordPress theme or page builder layout."
      }
    },
    {
      "@type": "Question",
      "name": "What tools do you use for design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I mainly use Adobe Photoshop for PSD design, along with Figma and Adobe XD for UI/UX when required."
      }
    },
    {
      "@type": "Question",
      "name": "Will the PSD design be responsive?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I design layouts with responsiveness in mind, including separate views for desktop, tablet, and mobile — so your developer can build accordingly."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer UI/UX design for apps?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, I design modern, clean user interfaces in PSD for mobile apps, dashboards, and web applications with UX best practices in mind."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to design a PSD layout?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "A basic website layout takes 2–3 days, while full websites with multiple pages or app UIs can take up to a week or more depending on complexity."
      }
    },
    {
      "@type": "Question",
      "name": "Do you design ecommerce store layouts?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I create PSD designs for online stores, product pages, cart/checkout flows, and promotional banners tailored to your target audience."
      }
    },
    {
      "@type": "Question",
      "name": "Can you work with my developer or team?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I can collaborate with your developers, share design files, style guides, and assist during handoff for smooth integration."
      }
    },
    {
      "@type": "Question",
      "name": "Is the design 100% original and copyright-free?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Every design is custom-made for your brand and business. You own full rights to the final PSD files delivered."
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>PSD Design Services in Gurgaon | UI/UX & Web Design by Pankaj</title>

<meta name="description" content="Custom PSD designs for websites, landing pages, and mobile apps. Pixel-perfect UI/UX layouts designed by freelance web designer Pankaj in Gurgaon." />

<meta name="keywords" content="psd design services, freelance psd designer, web design psd, ui ux design gurgaon, photoshop website design, custom psd layout, psd to html expert, landing page psd design, website design in photoshop, mobile app psd designer" />

<meta property="og:title" content="PSD Design Services in Gurgaon | UI/UX & Web Design by Pankaj" />
<meta property="og:description" content="Get creative, pixel-perfect PSD designs for websites and apps. Delivered by Pankaj, freelance UI/UX designer in Gurgaon." />
<meta property="og:site_name" content="Pankaj | Freelance PSD & Web Designer" />
<meta property="og:url" content="https://www.pankj.com/psd-design" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />

<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="PSD Design Services in Gurgaon | UI/UX & Web Design by Pankaj" />
<meta name="twitter:description" content="Professional PSD design services for responsive websites, mobile apps & eCommerce — by Pankaj, freelance designer in India." />

<link rel="canonical" href="https://www.pankj.com/psd-design" />

</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
{/*                <source src="assets/img/bg.mp4" type="video/mp4" />*/}
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />

 <h1 className="multiple_effects fzsml" id="text3d">PSD Design</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="best web designer in gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   



    <main id="main">

 <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>PSD Design</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
<div class="hero-section text-center">
  <p>Creative and Pixel-Perfect PSD Design Services for Websites, Apps, and eCommerce</p>
  <a href="/contact" class="btn btn-primary mt-3">Get a Custom PSD Design</a>
</div>

<div class="intro-section py-5">
  <h2>What Is PSD Design?</h2>
  <p>PSD design refers to the creation of web or app layouts in Adobe Photoshop, saved as layered .PSD files. These designs serve as blueprints before development, ensuring pixel accuracy, visual consistency, and a better user experience.</p>
  <p>As a freelance UI/UX and web designer in Gurgaon, I offer professional PSD design services tailored to your business goals — whether for a landing page, full website, or mobile app interface.</p>
</div>

<div class="services-section py-5">
  <h2>What’s Included in My PSD Design Services</h2>
  <ul>
    <li>✅ Custom website layout design in PSD format</li>
    <li>✅ Mobile app screens and dashboard UI</li>
    <li>✅ Homepage, inner pages, landing pages</li>
    <li>✅ E-commerce store and product page PSDs</li>
    <li>✅ Typography, color, and spacing guidelines</li>
    <li>✅ PSD to HTML-ready layering and organization</li>
    <li>✅ Figma or XD to PSD conversion (if needed)</li>
  </ul>
</div>

<div class="why-choose-me py-5">
  <h2>Why Choose Me for PSD Design?</h2>
  <p>✔ 11+ Years of Web & UI/UX Design Experience</p>
  <p>✔ 100% Custom, Pixel-Perfect PSDs</p>
  <p>✔ Designed for Developers — Layered and Organized</p>
  <p>✔ Experience with Landing Pages, SaaS, eCommerce & More</p>
  <p>✔ Quick Delivery with Unlimited Revisions (Until Approved)</p>
</div>

<div class="faq-section py-5">
  <h2>Frequently Asked Questions</h2>

  <div class="faq-item">
    <h3>Do you design responsive PSD layouts?</h3>
    <p>Yes. I create multiple versions (desktop, tablet, mobile) or ensure the layout is responsive-ready for developer conversion.</p>
  </div>

  <div class="faq-item">
    <h3>What tools do you use?</h3>
    <p>I primarily use Adobe Photoshop, but can also work with Figma and Adobe XD based on your needs.</p>
  </div>

  <div class="faq-item">
    <h3>Can I get my PSD converted to HTML?</h3>
    <p>Yes. I offer PSD to responsive HTML/CSS conversion if you need development as well.</p>
  </div>

  <div class="faq-item">
    <h3>Do you provide editable source files?</h3>
    <p>Yes. All final .PSD files are layered, organized, and fully editable for your team or developer.</p>
  </div>

  <div class="faq-item">
    <h3>How long does it take to design a PSD layout?</h3>
    <p>Basic layouts take 2–3 days. Full websites or apps may take 5–10 days depending on the number of screens.</p>
  </div>
</div>

<div class="cta-section py-5 text-center">
  <h2>Let’s Design Something Stunning</h2>
  <p>Reach out for pixel-perfect, clean PSD layouts — built to convert and easy for developers to use.</p>
  <a href="/contact" class="btn btn-success mt-3">Request a Free Quote</a>
</div>

          </div>

        </div>
      </div>

    </section> 
       <Contact /> 
    </main>
    </>
  );
}
export default App1;
